import styled from 'styled-components';

export const LogoContainer = styled.div`
  width: 100%
  .cls-1 {
    fill: ${props => (props.theme.palette.primary.contrastText)} !important;
  }
`;